// @flow

// Selectors
import assets$ from './selectors/assets'
import tableState$ from './selectors/tableState'

// DataTable Compose
import composeAssetsDataTable from 'fc-datatable-assets'

export default composeAssetsDataTable({
  assets$,
  tableState$,
})
